import { legalEntityFinancialsValidationRules } from 'features/new-actor/form/validation-rules/optim/legalEntityFinancialsValidationRules';
import { baseLegalEntityValidationRules } from 'features/new-actor/form/validation-rules/baseLegalEntityValidationRules';
import { SubsidiaryFormField, SubsidiaryFormValues } from 'features/new-actor/types/optim/subsidiaryFormValues';
import { getRegistrationNumberRefusal } from 'features/new-actor/utils/subsidiariesGuards';
import { ValidationRules } from 'helpers/createFormConfig';
import { BaseLegalEntityFormFieldNames } from 'shared/enums/baseLegalEntityFormFieldNames';
import * as Yup from 'yup';

// The figures follow the parent company's rules: required, the mappers turn an empty number into 0.
export const subsidiaryValidationRules: ValidationRules<SubsidiaryFormField> = {
  companyName: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .max(200, 'La désignation ne peut pas dépasser 200 caractères'),
  registrationNumber: baseLegalEntityValidationRules[BaseLegalEntityFormFieldNames.RegistrationNumber],
  ...legalEntityFinancialsValidationRules
};

export interface SubsidiaryValidationContext {
  parentRegistrationNumber?: string | null;
  subsidiaries?: SubsidiaryFormValues[];
  /** Row being edited, excluded from the duplicate check. */
  currentId?: string;
}

/** Translation of the ACTOR_FORM namespace: the refusal texts live in SUBSIDIARIES.ERRORS. */
export type SubsidiaryValidationTranslate = (key: string) => string;

export const buildSubsidiaryValidationSchema = (
  { parentRegistrationNumber, subsidiaries, currentId }: SubsidiaryValidationContext = {},
  t: SubsidiaryValidationTranslate = key => key
) =>
  Yup.object({
    ...subsidiaryValidationRules,
    registrationNumber: subsidiaryValidationRules.registrationNumber.test(
      'subsidiary-registration-number',
      function (value) {
        const refusal = getRegistrationNumberRefusal(value, parentRegistrationNumber, subsidiaries, currentId);
        return refusal
          ? this.createError({ message: t(`ACTOR_FORM.LEGAL_ENTITY.SUBSIDIARIES.ERRORS.${refusal}`) })
          : true;
      }
    )
  });
